import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callAPI from '../../../API/callSecureAPI'
import { ONE_MINUTE } from '../../constants/timing'
import { useSelector } from 'react-redux'

export type ValueNarrativeCategory = {
    _id: string
    name: string
    order: number
    organizationId: string
}

export const useGetValueNarrativeCategoriesQuery = () => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    // @ts-expect-error store is not typed properly
    const organizationId = useSelector((state) => state.strategy?.organizationId)

    const getCategories = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const response = await callAPI(
                endpoints.getNarrativeCategories.url + organizationId,
                endpoints.getNarrativeCategories.method,
                token
            )

            return response.data as ValueNarrativeCategory[]
        } catch (e) {
            console.log(e)
            return []
        }
    }

    return useQuery<ValueNarrativeCategory[]>(['valueNarrativeCategories', organizationId], getCategories, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!organizationId,

        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,

        cacheTime: ONE_MINUTE,
        staleTime: ONE_MINUTE,
    })
}
